export default __webpack_public_path__ + "assets/cart-check.22d0add8.webp";